import React from "react";
import { CloseIcon } from "../../../assets/images";
type AppProps = {
  data: any[];
  type?: string;
  onClose: (id: number | string) => void;
  disable?: boolean;
};

const MultiSelect = ({ data, onClose, type, disable }: AppProps) => {
  return (
    <div className="d-flex align-items-center justify-content-start mt-2 mb-2">
      {data &&
        data?.map((singleItem: any) => {
          return (
            singleItem &&
            (singleItem?.name?.trim() || singleItem?.label) && (
              <div
                className="mr-1 d-flex align-items-center justify-content-center"
                style={{
                  borderRadius: "50px",
                  border: "1px solid #6c757d",
                  backgroundColor: "#f3f6f8",
                  padding: "1px 2px",
                }}
              >
                <small style={{ padding: "4px 10px" }}>
                  {type === "gstr"
                    ? singleItem?._id
                    : singleItem?.name || singleItem?.label}{" "}
                  <span
                    onClick={() =>
                      onClose(singleItem?._id || singleItem?.value)
                    }
                    className="pointer"
                  >
                    {!disable ? (
                      <img width={13} src={CloseIcon} alt="" />
                    ) : null}
                  </span>
                </small>
              </div>
            )
          );
        })}
    </div>
  );
};

export default MultiSelect;
